(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/use-custom-events.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/use-custom-events.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const useCustomEvents = _ref => {
  let ticketInfo = _ref.ticketInfo,
    wager = _ref.wager,
    isDemo = _ref.isDemo,
    onClose = _ref.onClose,
    onPlay = _ref.onPlay,
    dispatch = _ref.dispatch,
    updateCategories = _ref.updateCategories;
  const gameEngineCode = svs.ticketgames.ticketUtility.utils.constants.leia.gameEngineCode;
  const resultDialogDemo = svs.ticketgames.ticketUtility.utils.resultDialog.resultDialogDemo;
  const _React = React,
    useState = _React.useState,
    useRef = _React.useRef;
  const _svs$eInstant$lobby$p = svs.eInstant.lobby.play.utils,
    showReceipt = _svs$eInstant$lobby$p.showReceipt,
    showOngoingDialog = _svs$eInstant$lobby$p.showOngoingDialog;
  const lastWonAmountRef = useRef(-1);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(Boolean(wager)),
    _useState4 = _slicedToArray(_useState3, 2),
    isOngoingGame = _useState4[0],
    setIsOngoingGame = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPlayAgain = _useState6[0],
    setShowPlayAgain = _useState6[1];
  const shouldShowPlayAgain = ticketInfo.open && (wager === null || wager === void 0 ? void 0 : wager.completed) && showPlayAgain;
  const GAME_RESUMED = svs.eInstant.lobby.play.leia.ticketEvents.GAME_RESUMED;
  const getLastWonAmount = () => lastWonAmountRef.current;
  const handleGameLoaded = () => {
    setIsLoading(false);
    svs.eInstant.lobby.play.utils.hideHeaders(true);
    if (wager !== null && wager !== void 0 && wager.completed) {
      showReceipt();
      setShowPlayAgain(true);
    }
  };
  const handleOngoingGame = data => {
    if (data.detail) {
      var _requestResponse$data;
      const _data$detail = data.detail,
        event = _data$detail.event,
        _data$detail$requestR = _data$detail.requestResponse,
        requestResponse = _data$detail$requestR === void 0 ? {} : _data$detail$requestR,
        eventType = _data$detail.eventType,
        type = _data$detail.type;
      if (type === GAME_RESUMED && !isOngoingGame) {
        showOngoingDialog();
      }
      if ((event === 'getItgTickets' || event === 'getEinTickets') && eventType === 'requestResponse' && requestResponse.data.length >= 1) {
        if (!wager) {
          dispatch({
            type: 'SET_BET_ID',
            payload: requestResponse.data[0].id
          });
          showOngoingDialog();
          setIsOngoingGame(false);
        }
      }
      if (isOngoingGame && event === 'updateItgBet' && eventType === 'requestResponse' && (_requestResponse$data = requestResponse.data) !== null && _requestResponse$data !== void 0 && _requestResponse$data.data && !wager) {
        var _requestResponse$data2;
        dispatch({
          type: 'SET_BET_ID',
          payload: (_requestResponse$data2 = requestResponse.data.data) === null || _requestResponse$data2 === void 0 ? void 0 : _requestResponse$data2.id
        });
        setIsOngoingGame(false);
        showOngoingDialog();
      }
    }
  };
  const handleHasClaimed = data => {
    if (data !== null && data !== void 0 && data.detail) {
      const detail = data.detail;
      let playAgain;
      switch (ticketInfo.gameEngineCode) {
        case gameEngineCode.VEIKKAUS:
          playAgain = () => {
            var _gameloaderHelper$ins;
            (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.bridgeWindow) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.postMessage({
              type: 'confirm',
              data: {
                context: 'rebuy',
                option: 'cancel' 
              }
            }, svs.ticketUtility.data.gameloaderHelperConfig.itf.url);
          };
          break;
        default:
          break;
      }
      if (isDemo) {
        var _detail$wonAmount;
        lastWonAmountRef.current = (detail === null || detail === void 0 || (_detail$wonAmount = detail.wonAmount) === null || _detail$wonAmount === void 0 ? void 0 : _detail$wonAmount.value) / 100;
        resultDialogDemo({
          wonAmount: detail === null || detail === void 0 ? void 0 : detail.wonAmount,
          onClose: () => {
            onClose(ticketInfo, {
              isDemo: true,
              winAmount: lastWonAmountRef.current,
              anchorId: 'similargames'
            });
          },
          onPlayAgain: () => onPlay(ticketInfo)
        });
      } else {
        svs.components.account_balance.get(true);
        if (!wager || !wager.completed) {
          var _detail$wonAmount2;
          updateCategories();
          lastWonAmountRef.current = (detail === null || detail === void 0 || (_detail$wonAmount2 = detail.wonAmount) === null || _detail$wonAmount2 === void 0 ? void 0 : _detail$wonAmount2.value) / 100;
        }
        svs.ticketgames.ticketUtility.utils.resultDialog.resultDialogNormal({
          wonAmount: detail === null || detail === void 0 ? void 0 : detail.wonAmount,
          onClose: () => {
            onClose(ticketInfo, {
              isCompleted: wager === null || wager === void 0 ? void 0 : wager.completed,
              winAmount: lastWonAmountRef.current,
              anchorId: 'similargames'
            });
          },
          onPlayAgain: wager ? () => onPlay(ticketInfo) : playAgain,
          isTicketOpen: ticketInfo.open
        });
      }
    }
  };
  const handleHasBet = _ref2 => {
    let detail = _ref2.detail;
    if (!isDemo) {
      var _data$id, _data$id2;
      const data = detail.data,
        platformBetId = detail.platformBetId,
        betAmount = detail.betAmount,
        serviceName = detail.serviceName;
      dispatch({
        type: 'SET_BET_ID',
        payload: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : platformBetId
      });
      const ticketPrice = betAmount.value / 100;
      svs.ticketgames.ticketUtility.utils.tracking.sendAnalytics((_data$id2 = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id2 !== void 0 ? _data$id2 : platformBetId, serviceName, ticketPrice, ticketInfo, false);
    }
  };
  return {
    isLoading,
    shouldShowPlayAgain,
    getLastWonAmount,
    handleGameLoaded,
    handleOngoingGame,
    handleHasClaimed,
    handleHasBet
  };
};
setGlobal('svs.eInstant.lobby.play.leia.useCustomEvents', useCustomEvents);

 })(window);